import { Container, SectionTitle } from "components";
import React from "react";

function ComingSoon() {
  return (
    <section className="comingSoon relative py-[40px] laptop:pt-[90px] laptop:pb-[160px]">
      <Container>
        {/* <h2 className="text-center text-[40px] md:text-[80px] laptop:text-[160px] font-bold text-outline">
          Coming Soon!
        </h2>

        <div className="absolute text-center text-[30px] md:text-[70px] laptop:text-[150px] font-bold outline-text">
          Coming Soon!
        </div> */}
        {/* <SectionTitle title="Launching in July!" /> */}
        <SectionTitle title="Launching Soon" />
      </Container>
    </section>
  );
}

export default ComingSoon;
